Apt.fn.extend('account.profile', {}, {
	/**
	 * Initialize map functionality
	 */
	pinpoint() {
		const scope = this;
		const center = scope.center || [-98.5795, 39.8282];

		scope.map = Apt.fn.maps()
			.init('$map', {
				basic: true,
				center: center,
				dragRotate: false,
				maxZoom: 9,
				style: 'dynamic',
				zoom: scope.center ?
					8 : 2.5,
				ready: () => {
					const map = scope.map;

					scope.canvas = map.map.getCanvas();

					scope.marker = {
						type: 'Feature',
						geometry: {
							type: 'Point',
							coordinates: center
						}
					};

					map.$private.addSource('marker', {
						type: 'geojson',
						data: scope.marker
					});

					map.$private.addLayer({
						id: 'marker',
						type: 'circle',
						source: 'marker',
						paint: {
							'circle-color': '#c77474',
							'circle-radius': 5,
							'circle-stroke-color': '#f2f9f5',
							'circle-stroke-opacity': 0.6,
							'circle-stroke-width': 10
						}
					});

					map.bind('marker', 'mouseenter', () => {
						scope.canvas.style.cursor = 'move';
					});

					map.bind('marker', 'mouseleave', () => {
						scope.canvas.style.cursor = '';
					});

					map.bind('marker', 'mousedown', e => {
						scope.canvas.style.cursor = 'grab';

						e.preventDefault();

						map.bind('map', 'mousemove', scope.markerMove);
						map.bind('map', 'mouseup', scope.markerStop, true);
					});

					map.bind('point', 'touchstart', e => {
						if (e.points.length !== 1) {
							return;
						}

						e.preventDefault();

						map.bind('map', 'touchmove', scope.markerMove);
						map.bind('map', 'touchend', scope.markerStop, true);
					});

					map.bind('map', 'mousedown', e => {
						const coords = e.lngLat;

						scope.setPosition([
							coords.lng,
							coords.lat
						]);
					});
				}
			});
	},

	/**
	 * Set marker center
	 *
	 * @param {Array} center
	 * @param {Boolean} [move=false]
	 */
	setPosition(center, move) {
		const scope = this;

		if (scope.marker) {
			scope.marker.geometry.coordinates = center;

			scope.map.map.getSource('marker')
				.setData(scope.marker);
		}

		if (move) {
			scope.map.center(center, {
				zoom: 6
			});
		}

		scope.center = center;
	},

	/**
	 * Move the marker
	 *
	 * @param {Object} e
	 */
	markerMove(e) {
		const scope = Apt['account.profile'].$private;

		scope.canvas.style.cursor = 'grabbing';

		scope.marker.geometry.coordinates = [
			e.lngLat.lng,
			e.lngLat.lat
		];

		scope.map.map.getSource('marker')
			.setData(scope.marker);
	},

	/**
	 * Stop the marker movement
	 *
	 * @param {Object} e
	 */
	markerStop(e) {
		const scope = Apt['account.profile'].$private;

		scope.setPosition([
			e.lngLat.lng,
			e.lngLat.lat
		], false);

		scope.canvas.style.cursor = '';

		scope.map.unbind('map', 'mousemove', scope.markerMove);
		scope.map.unbind('map', 'touchmove', scope.markerStop);
	}
});